import { Link, router } from '@inertiajs/react'
import { Section } from '@/components/design-system/Section'
import { formatDate } from '@/frontend/pages/CommandCenter/Telemetry/utils'

interface AuditLogEntry {
  id: string
  description: string
  actor_name: string | null
  organization_name: string
  worker_name: string | null
  worker_path: string | null
  created_at: string
}

interface Props {
  logs: AuditLogEntry[]
}

export default function RecentActivitySection({ logs }: Props) {
  return (
    <Section title="Atividade Recente" action={{ content: 'Ver auditoria', onAction: () => router.visit('/cc/audit_logs') }}>
      {logs.length === 0 ? (
        <p className="text-sm text-muted-foreground py-4 text-center">Nenhuma atividade recente.</p>
      ) : (
        <div className="space-y-1">
          {logs.map((log) => (
            <div key={log.id} className="flex items-start gap-3 py-2 border-b border-border last:border-0">
              <span className="text-xs text-muted-foreground whitespace-nowrap flex-shrink-0 pt-0.5">
                {formatDate(log.created_at)}
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-sm text-foreground truncate">{log.description}</p>
                <p className="text-xs text-muted-foreground">
                  {log.actor_name && <span>{log.actor_name}</span>}
                  {log.actor_name && log.organization_name && <span> · </span>}
                  <span>{log.organization_name}</span>
                  {log.worker_name && log.worker_path && (
                    <>
                      <span> · </span>
                      <Link href={log.worker_path} className="hover:text-blue-600">{log.worker_name}</Link>
                    </>
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </Section>
  )
}
